import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyerNotifications } from '../data/content';
const MINUTES = [2, 3, 4, 6, 7, 8, 9, 11, 12, 14];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    if (dismissed) return;
    let cancelled = false;
    const schedule = (delay: number) => {
      const showId = window.setTimeout(() => {
        if (cancelled) return;
        setVisible(true);
        const hideId = window.setTimeout(() => {
          if (cancelled) return;
          setVisible(false);
          setIndex(prev => (prev + 1) % buyerNotifications.length);
          schedule(9000 + Math.random() * 7000);
        }, 5200);
        timers.current.push(hideId);
      }, delay);
      timers.current.push(showId);
    };
    schedule(7000);
    return () => {
      cancelled = true;
      timers.current.forEach(id => window.clearTimeout(id));
      timers.current = [];
    };
  }, [dismissed]);
  const buyer = buyerNotifications[index];
  const minutesAgo = MINUTES[index % MINUTES.length];
  return <AnimatePresence data-id="element-257" data-mp="1aw63690rl254">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: -24,
      scale: 0.96
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: -24,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 z-30 w-[min(20rem,calc(100vw-1.5rem))] sm:bottom-28 sm:left-5" role="status" aria-live="polite" data-id="element-258" data-mp="1aysg6o6fc9uq">
          <div className="relative flex items-start gap-3 rounded-2xl border border-navy-900/10 bg-white p-3 pr-8 shadow-[0_18px_40px_-16px_rgba(7,20,41,0.45)]" data-id="element-259" data-mp="28kg74tk41zyv">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-green-50" data-id="element-260" data-mp="23l3j45hi6mup">
              <CheckCircle2Icon className="h-5 w-5 text-green-600" aria-hidden="true" data-id="element-261" data-mp="2aqntuvbyk16x" />
            </span>
            <div className="min-w-0" data-id="element-262" data-mp="2fphauxqgeabu">
              <p className="text-[13px] font-bold leading-snug text-navy-900" data-id="element-263" data-mp="2kmhhb9r7tf3h">
                {buyer.name}
              </p>
              <p className="text-[12px] leading-snug text-navy-900/70" data-id="element-264" data-mp="2plbvtzi5ghhs">
                ha appena acquistato il Sistema Maestro della TRT™
              </p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-navy-900/45" data-id="element-265" data-mp="1wwwswbcalpmt">
                {buyer.place} · {minutesAgo} min fa
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Chiudi notifica" className="absolute right-1.5 top-1.5 rounded-md p-1 text-navy-900/35 transition-colors duration-150 ease-out hover:bg-navy-50 hover:text-navy-900" data-id="element-266" data-mp="26mzomjasthou">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-267" data-mp="3rhgjr37djyym" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}